export function dataInRequest(params = {}) {
  return {
    type: '@afericaoAreiaSilo/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@afericaoAreiaSilo/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@afericaoAreiaSilo/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@afericaoAreiaSilo/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@afericaoAreiaSilo/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@afericaoAreiaSilo/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@afericaoAreiaSilo/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@afericaoAreiaSilo/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@afericaoAreiaSilo/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@afericaoAreiaSilo/RECORD_FILTERING',
    payload: { params },
  };
}
